<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane :label="`岗位数据分析`" name="jobDataAnalysis"> </el-tab-pane>
        <el-tab-pane :label="`违规排名`" name="violationRanking"> </el-tab-pane>
        <el-tab-pane :label="`违规占比`" name="violationProportion"> </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import jobDataAnalysis from "./jobDataAnalysis/jobDataAnalysis";
import violationRanking from "./violationRanking/violationRanking";
import violationProportion from "./violationProportion/violationProportion";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'QualityInspectionAnalysis',
  mixins: [pagePathMixin],
  components: { jobDataAnalysis, violationRanking, violationProportion },
  data() {
    return {
      activeName: "jobDataAnalysis",
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
